// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#545c64","menuText":"#fff","menuActiveText":"#42b983"};